import { LambdaSchema } from "./types";

const schema: LambdaSchema = {
  columns: [
    // { key: "platform", label: "platform" },
    { key: "conversation_id", label: "conversation_id" },
    { key: "job_name", label: "job_name" },
    // { key: "s3_source_key", label: "s3_source_key" },
    { key: "service_used", label: "service_used" },
    { key: "audio_length_seconds", label: "audio length (s)" },
    { key: "transcription_duration_ms", label: "transcription duration (ms)", transform: "secondsFromMs" },
    // { key: "transcript_url", label: "transcript_url", transform: "link" },
    { key: "request_id", label: "request_id" }
  ],
};

export default schema;

